<template>
    <div class="page-container">
        <div class="page-top">
            <div class="total">
                <div class="total-box">
                    <div class="total-num">{{pageData.recommendAmount}}</div>
                    <div class="total-text">推荐奖励账户余额(元)</div>
                </div>
                <div class="btn-duihuan" @click="jumpDh">奖励兑换</div>
            </div>
            <div class="detail">
                <div class="detail-item">
                    <div class="item-num">{{pageData.recommendUsed}}</div>
                    <div class="item-text">已兑换奖励</div>
                </div>
                <div class="detail-item">
                    <div class="item-num">{{pageData.recommendTotal}}</div>
                    <div class="item-text">累计已获奖励</div>
                </div>
            </div>
        </div>
        <div class="page-bottom">
            <div class="bottom-item" @click="jumpOrderList">
                <img src="../../assets/icon-tjjl.png" alt="">
                <div class="text">推荐奖励账单</div>
            </div>
            <div class="bottom-item" @click="jumpTjdr">
                <img src="../../assets/icon-wtjdr.png" alt="">
                <div class="text">我推荐的人</div>
            </div>
        </div>
        <div class="bottom-links">
            <router-link to="/reward/rules?role=reward" class="link-item">奖励政策</router-link>
        </div>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast} from 'vant'

export default {
    data(){
        return {
            pageData:{},
        }
    },
    components:{
        [Toast.name]:Toast
    },
    activated(){
        $http({
            method:'post',
            url:config.api.referralReward
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        jumpDh(){
            this.$router.push({
                name:'use-referral'
            });
        },
        jumpOrderList(){
            this.$router.push({
                name:'referral-list',
                params:{
                    recommendTotal:this.pageData.recommendTotal,
                    recommendRelease:this.pageData.recommendRelease,
                    recommendUsed:this.pageData.recommendUsed
                }
            });
        },
        jumpTjdr(){
            this.$router.push({
                name:'my-recommend'
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.page-container{
    background: #f5f5f5;
    min-height: 100vh;
    .page-top{
        padding:25px 20px;
        background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
        color:#fff;
        margin-bottom: 10px;
        .total{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .total-box{
                .total-num{
                    font-size: 30px;
                    line-height: 35px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                .total-text{
                    font-size: 13px;
                    line-height: 18px;
                    color:rgba(255,255,255,0.7);
                }
            }
            .btn-duihuan{
                font-size: 14px;
                height:30px;
                line-height: 30px;
                padding:0 12px;
                background: #fff;
                box-shadow: 0px 0px 6px -2px #2277E1;
                border-radius: 26px;
                color:#3088F5;
            }
        }
        .detail{
            margin-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .detail-item{
                width:50%;
                .item-num{
                    font-weight: bold;
                    line-height: 21px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    margin-bottom: 5px;
                }
                .item-text{
                    line-height: 18px;
                    font-size: 13px;
                    color:rgba(255,255,255,0.7);
                }
            }
        }
    }
    .page-bottom{
        background:#fff;
        padding:20px 0;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        .bottom-item{
            width:50%;
            text-align: center;
            box-sizing: border-box;
            &:first-child{
                border-right: 1px solid #f0f0f0;
            }
            &>img{
                width:48px;
                height:44px;
                margin-bottom: 12px;
            }
            .text{
                font-size: 16px;
                color:#333;
            }
        }
    }
    .bottom-links{
        width:100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        text-align: center;
        padding-bottom: 10px;
        .link-item{
            font-size: 14px;
            color:#3088F5;
            line-height: 20px;
        }
    }
}
</style>